import {
  FormControl,
  IconButton,
  InputBase,
  makeStyles,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import Button from './Button'

const useStyles = makeStyles(theme => ({
  root: {
    flexDirection: 'row',
  },
  clearArea: {
    display: 'flex',
    width: 30,
  },
  input: ({ size }) => ({
    backgroundColor: 'white',
    border: `1px solid ${theme.palette.lightPurple.main}`,
    borderTopLeftRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: theme.shape.borderRadius,
    paddingLeft: theme.spacing(size === 'large' ? 1.5 : 1),
  }),
  button: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
}))

const SearchInput = ({
  autoFocus,
  buttonProps = {},
  className,
  goText,
  inputProps,
  onChange,
  placeholder,
  size,
  value,
  ...props
}) => {
  const classes = useStyles({ size })
  const [text, setText] = useState(value)

  useEffect(() => {
    setText(value)
  }, [value])

  const handleChange = event => {
    console.info('change')
    setText(event.target.value)
  }
  const handleClear = () => {
    console.info('clear')
    setText('')
    onChange('')
  }
  const handleSubmit = () => {
    console.log('submit')
    return onChange(text)
  }
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleSubmit()
    }
  }

  return (
    <FormControl className={clsx(classes.root, className)} {...props}>
      <InputBase
        autoFocus={autoFocus}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        endAdornment={
          <div className={classes.clearArea}>
            {!!text && (
              <IconButton onClick={handleClear} size="small">
                <CloseIcon />
              </IconButton>
            )}
          </div>
        }
        placeholder={placeholder}
        value={text}
        {...inputProps}
        className={clsx(classes.input, inputProps.className)}
      />
      <Button
        className={classes.button}
        color="purple"
        onClick={handleSubmit}
        size={size}
        {...buttonProps}
      >
        {goText}
      </Button>
    </FormControl>
  )
}

SearchInput.defaultProps = {
  autoFocus: true,
  goText: 'Go',
  inputProps: {},
  placeholder: 'Search...',
}

SearchInput.propTypes = {
  autoFocus: PropTypes.bool,
  goText: PropTypes.string,
  onChange: PropTypes.func,
  inputProps: PropTypes.object,
  placeholder: PropTypes.string,
  sizelaceholder: PropTypes.string,
  value: PropTypes.any,
}

export default SearchInput
